import { useSelector } from "react-redux";
import { If } from "react-extras";
import { Link } from "react-router-dom";
import { Button, Col } from "react-bootstrap";
import ExternalLink from "../../../lib/external_link";
import React from "react";

export const GettingStarted = props => {
  const { openModal } = props;

  const user = useSelector(state => state.user?.user);

  return (
    <div className="flex-column-container align-center">
      <If condition={!user?.isStripeConnected}>
        <p>
          Before getting started with advertising, you need to{" "}
          <Link to={"/monetization"}>connect your banking info with RedCircle.</Link>
        </p>
      </If>
      <If condition={!!user?.isStripeConnected}>
        <Col sm={12}>
          <p className={"margin-top--large"}>
            Set up your Advertising profile now to start partnering with verified brands and
            generate revenue with ads that excite your listeners. You have complete control over the
            rates you set, the types of ads, and which campaign offers you accept - we’ll never put
            ads on your show that you haven’t approved.
          </p>
        </Col>
        <Col sm={12} md={8} className="margin-top--medium">
          <Button className="btn btn-primary width-100" onClick={openModal}>
            Get Started
          </Button>
        </Col>
        <Col>
          <ExternalLink
            className="bold"
            to={"http://support.redcircle.com/en/articles/3591720-advertising"}>
            Learn More...
          </ExternalLink>
        </Col>
      </If>
    </div>
  );
};
